import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import {
  createShippingCharges,
  getShippingChargesRecords,
  updateShippingCharges,
  deleteShippingCharges
} from "../../helper/api_helper";
import toast from "react-hot-toast";
import CountryDropdown from "../../components/CountryDropdown";
import { countries } from "../../helper/countries";
import { Icon } from "@iconify/react/dist/iconify.js";
const Configuration = () => {
  const [isCreateOpen, setIsCreateOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isPageLoading, setIsPageLoading] = useState(false);

  const [deleteId, setDeleteId] = useState(null);
  const [records, setRecords] = useState([]);
  const [formData, setFormData] = useState({
    origin: "",
    delivery: "",
    shipPrice: "",
    shipDurationFrom: "",
    shipDurationTo: "",
    airPrice: "",
    airDurationTo: "",
    airDurationFrom: "",
  });



  console.log("FORM DATA ::", formData);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  const getShippingRecords = async () => {
    try {
      setIsPageLoading(true);
      let response = await getShippingChargesRecords();
      if (response.status) {
        console.log("RESPONSE ::", response.data);
        setRecords(response.data);
      }
    } catch (error) {
      console.log(error);
    }
    setIsPageLoading(false);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      let response;
      if (isEditing && editingId) {
        // Update existing record
        response = await updateShippingCharges(editingId, formData);
      } else {
        // Create new record
        response = await createShippingCharges(formData);
      }
      console.log("RESPONSE ::", response);
      if (response.status) {
        toast.success(response.message || (isEditing ? "Updated successfully" : "Created successfully"));
        setIsCreateOpen(false);
        setIsEditing(false);
        setEditingId(null);
        setFormData({
          origin: "",
          delivery: "",
          shipPrice: "",
          shipDurationFrom: "",
          shipDurationTo: "",
          airPrice: "",
          airDurationTo: "",
          airDurationFrom: "",
        });
        getShippingRecords();
      }
    } catch (error) {
      console.log(error);
      toast.error(error || "Something went wrong");
    }
  };

  const handleEdit = (item) => {
    setFormData({
      origin: item.origin || "",
      delivery: item.delivery || "",
      // Ship fields
      shipPrice: item.shipPrice || "",
      shipDurationFrom: item.shipDurationFrom || "",
      shipDurationTo: item.shipDurationTo || "",
      // Air fields
      airPrice: item.rate_per_kg || "",
      airDurationFrom: item.airDurationFrom || "",
      airDurationTo: item.airDurationTo || "",
    });
    setEditingId(item.id);
    setIsEditing(true);
    setIsCreateOpen(true);
  };

  const handleDeleteClick = (item) => {
    setDeleteId(item.id);
    setShowDeleteModal(true);
  };

  const handleDeleteConfirm = async () => {
    if (!deleteId) return;

    const toastId = toast.loading("Deleting...");
    try {
      const response = await deleteShippingCharges(deleteId);
      if (response.status) {
        toast.success(response.message || "Deleted successfully", { id: toastId });
        setShowDeleteModal(false);
        setDeleteId(null);
        getShippingRecords();
      }
    } catch (error) {
      console.log(error);
      toast.error(error || "Failed to delete", { id: toastId });
    }
  };

  useEffect(() => {
    getShippingRecords();
  }, []);

  const [currentPage, setCurrentPage] = useState(1);

  const [itemsPerPage] = useState(10);
  const totalItems = records?.length || 0;
  const itemsPerPageSafe = itemsPerPage || 1;
  const totalPages = Math.ceil(totalItems / itemsPerPageSafe);
  const startIdx = (currentPage - 1) * itemsPerPage;
  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };
  return (
    <MasterLayout>
      <Breadcrumb title="Configuration" />
      <div className="col-lg-12">
        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h5 className="card-title mb-0">Configuration</h5>

            <button
              type="button"
              className="btn btn-primary-600 radius-8 px-20 py-11"
              onClick={() => {
                setFormData({
                  origin: "",
                  delivery: "",
                  shipPrice: "",
                  shipDurationFrom: "",
                  shipDurationTo: "",
                  airPrice: "",
                  airDurationTo: "",
                  airDurationFrom: "",
                });
                setIsEditing(false);
                setEditingId(null);
                setIsCreateOpen(!isCreateOpen);
              }}
            >
              + Add
            </button>
          </div>

          <div className="card-body">
            <div className="table-responsive">


              {isPageLoading ? (
                <div className="text-center py-40">
                  <div className="spinner-border text-primary" role="status" />
                </div>
              ) : records?.length === 0 ? (
                <div className="text-center py-40 text-muted fw-medium">No Configuration found.</div>
              ) : (



                <table className="table basic-border-table mb-0">
                  <thead>
                    <tr>
                      <th>Origin Country</th>
                      <th>Delivery Country</th>
                      <th>Charge</th>
                      <th>Type Of Shipment</th>
                      <th>Duration</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {records?.slice(startIdx, startIdx + itemsPerPage)?.map((items, index) => {
                      const isShip = items.code === "ship";
                      const isAir = items.code === "air";
                      return (
                        <tr key={items.id}>
                          <td>{items.origin}</td>
                          <td>{items.delivery}</td>
                          <td>${items.rate_per_kg}</td>
                          <td>{items.code.toUpperCase()}</td>
                          <td>
                            {isShip ? items.shipDurationFrom : items.airDurationFrom} TO {isShip ? items.shipDurationTo : items.airDurationTo} {"Days"}
                          </td>
                          <td className="text-start">
                            <div className="d-flex align-items-start gap-10 justify-content-start">
                              <button
                                type="button"
                                className="bg-success-focus text-success-600 bg-hover-success-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                onClick={() => handleEdit(items)}
                              >
                                <Icon icon="lucide:edit" className="menu-icon" />
                              </button>

                              <button
                                type="button"
                                className="remove-item-btn bg-danger-focus bg-hover-danger-200 text-danger-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                onClick={() => handleDeleteClick(items)}
                              >
                                <Icon icon="fluent:delete-24-regular" className="menu-icon" />
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>


              )}
            </div>

            {records?.length > itemsPerPage &&


              <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mt-24 mb-10">
                <span>
                  Showing {startIdx + 1} to{" "}
                  {Math.min(startIdx + itemsPerPage, records?.length)} of{" "}
                  {records?.length} entries
                </span>
                <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
                  <li className="page-item">
                    <button
                      className="page-link text-secondary-light fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px me-8 w-32-px bg-base"
                      onClick={() => goToPage(currentPage - 1)}
                      disabled={currentPage === 1}
                    >
                      <Icon icon="ep:d-arrow-left" className="text-xl" />
                    </button>
                  </li>

                  {[...Array(totalPages)].map((_, index) => (
                    <li className="page-item" key={index}>
                      <button
                        className={`page-link ${currentPage === index + 1
                          ? "bg-primary-600 text-white"
                          : "bg-primary-50 text-secondary-light"
                          } fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px me-8 w-32-px`}
                        onClick={() => goToPage(index + 1)}
                      >
                        {index + 1}
                      </button>
                    </li>
                  ))}

                  <li className="page-item">
                    <button
                      className="page-link text-secondary-light fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px me-8 w-32-px bg-base"
                      onClick={() => goToPage(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    >
                      <Icon icon="ep:d-arrow-right" className="text-xl" />
                    </button>
                  </li>
                </ul>
              </div>}
          </div>
        </div>
        {/* card end */}
      </div>
      {isCreateOpen && (
        <>
          <div className="modal fade show d-block" tabIndex="-1">
            <div className="modal-dialog modal-dialog-centered modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">
                    {isEditing ? "Edit" : "Add"} Shipping & Air Freight Details
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setIsCreateOpen(false)}
                  ></button>
                </div>

                <div className="modal-body">
                  <form onSubmit={handleSubmit}>
                    {/* Ship Freight Section */}
                    <h6 className="mb-3 text-primary-600">Ship Freight</h6>
                    <div className="row g-3">
                      {/* Origin Country */}
                      <div className="col-md-6">
                        <CountryDropdown
                          id="origin"
                          name="origin"
                          value={formData.origin}
                          onChange={handleChange}
                          placeholder="Select origin country"
                          label="Origin Country"
                          // required={true}
                          countries={countries}
                        />
                      </div>

                      {/* Delivery Country */}
                      <div className="col-md-6">
                        <CountryDropdown
                          id="delivery"
                          name="delivery"
                          value={formData.delivery}
                          onChange={handleChange}
                          placeholder="Select delivery country"
                          label="Delivery Country"
                          // required={true}
                          countries={countries}
                        />
                      </div>

                      {/* Ship Price */}
                      <div className="col-md-6">
                        <label htmlFor="shipPrice" className="form-label">
                          Ship Price
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          id="shipPrice"
                          name="shipPrice"
                          value={formData.shipPrice}
                          onChange={handleChange}
                          placeholder="Enter ship price"
                          min="1"
                          step="1"
                          onKeyDown={(e) => e.key === "-" && e.preventDefault()}
                          required
                        />
                      </div>

                      {/* Duration Row (Flex) */}
                      <div className="col-md-6 d-flex align-items-end gap-2">
                        {/* Duration From */}
                        <div className="flex-grow-1">
                          <label className="form-label">Duration (From)</label>
                          <input
                            type="number"
                            className="form-control"
                            name="shipDurationFrom"
                            value={formData.shipDurationFrom}
                            onChange={handleChange}
                            placeholder="From"
                            required
                          />
                        </div>

                        <div className="fw-bold d-flex align-items-center">
                          TO
                        </div>

                        {/* Duration To */}
                        <div className="flex-grow-1">
                          <label className="form-label">Duration (To)</label>
                          <input
                            type="number"
                            className="form-control"
                            name="shipDurationTo"
                            value={formData.shipDurationTo}
                            onChange={handleChange}
                            placeholder="To"
                            required
                          />
                        </div>
                      </div>
                    </div>

                    {/* Divider */}
                    <div className="divider"></div>

                    {/* Air Freight Section */}
                    <h6 className="mb-3 text-primary-600 mt-3">Air Freight</h6>
                    <div className="row g-3">
                      <div className="col-md-6">
                        <label htmlFor="airPrice" className="form-label">
                          Air Price
                        </label>
                        <input
                          type="number"
                          className="form-control"
                          id="airPrice"
                          name="airPrice"
                          value={formData.airPrice}
                          onChange={handleChange}
                          placeholder="Enter air price"
                           min="1"
                          step="1"
                          onKeyDown={(e) => e.key === "-" && e.preventDefault()}
                          required
                        />
                      </div>
                      <div className="col-md-6 d-flex align-items-end gap-2">
                        {/* Duration From */}
                        <div className="flex-grow-1">
                          <label className="form-label">Duration (From)</label>
                          <input
                            type="number"
                            className="form-control"
                            name="airDurationFrom"
                            value={formData.airDurationFrom}
                            onChange={handleChange}
                            placeholder="From"
                            required
                          />
                        </div>

                        <div className="fw-bold d-flex align-items-center">
                          TO
                        </div>

                        {/* Duration To */}
                        <div className="flex-grow-1">
                          <label className="form-label">Duration (To)</label>
                          <input
                            type="number"
                            className="form-control"
                            name="airDurationTo"
                            value={formData.airDurationTo}
                            onChange={handleChange}
                            placeholder="To"
                            required
                          />
                        </div>
                      </div>
                    </div>

                    <div className="modal-footer " style={{ marginTop: "20px" }}>
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => setIsCreateOpen(false)}
                      >
                        Close
                      </button>
                      <button type="submit" className="btn btn-primary">
                        {isEditing ? "Update" : "Submit"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      )}

      {/* Delete Confirmation Modal */}
      {showDeleteModal && (
        <>
          <div className="modal fade show d-block" tabIndex="-1">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header bg-danger-focus">
                  <h5 className="modal-title text-danger-600">
                    {/* <Icon icon="mdi:alert-circle" className="me-2" /> */}
                    Confirm Delete
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => {
                      setShowDeleteModal(false);
                      setDeleteId(null);
                    }}
                  ></button>
                </div>

                <div className="modal-body text-center py-4">
                  <Icon
                    icon="mdi:delete-alert"
                    className="text-danger-600 mb-3"
                    style={{ fontSize: '64px' }}
                  />
                  <h6 className="" style={{ marginBottom: "12px" }}>Are you sure you want to delete this shipping charge?</h6>
                  <p className="text-muted mb-0" style={{ marginBottom: "12px" }}>This action cannot be undone.</p>
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => {
                      setShowDeleteModal(false);
                      setDeleteId(null);
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={handleDeleteConfirm}
                  >
                    {/* <Icon icon="fluent:delete-24-regular" className="me-1" /> */}
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-backdrop fade show"></div>
        </>
      )}
    </MasterLayout>
  );
};

export default Configuration;
